<template>
    <div>
        <div v-if="!isConnected">
            <loading></loading>
            <modal type="error">
                <template v-slot:title>Connection lost</template>
                <template v-slot:buttons><a href="/" class="btn btn--block btn--secondary">Refresh</a></template>
            </modal>
        </div>

        <div v-if="isConnected">
            <div v-if="currentState == 0">
                <loading></loading>
            </div>

            <div v-if="currentState == 5">
                <template v-if="knockoutGame">
                    <loading v-if="! gameInfo.isLastRound">
                        Loading
                        <template v-slot:subtitle>
                            Your opponent left the game, you won! Waiting for opponent...
                        </template>
                    </loading>
                    <loading v-else>
                        Your opponent left the game! You won the tournament, congratulation!
                        <template v-slot:subtitle>
                            <div class="game__footer mb--0">
                                <div>
                                    <button class="btn btn--action btn--white mb--sm" @click="emitFinishEvent()">Go to Room Dashboard</button>
                                </div>
                            </div>
                        </template>
                    </loading>
                </template>

                <template v-else>
                    <modal type="error">
                        <template v-slot:title>Your opponent left the game! Please start a new game!</template>
                        <template v-slot:buttons>
                            <button v-if="isGroupGame" @click="emitFinishEvent" class="btn btn--block btn--secondary">Back</button>
                            <a v-else href="/game/multiplayer/random" class="btn btn--block btn--secondary">Start new game</a>
                        </template>
                    </modal>
                    <loading></loading>
                </template>
            </div>

            <div v-if="currentState == 6 && knockoutGame && ! beforeRoundCounterReady">
                <loading>
                    Round started
                    <template v-slot:subtitle>{{ beforeRoundCounterValue }}</template>
                </loading>
            </div>

            <div v-if="currentState == 6 && (! knockoutGame || (knockoutGame && beforeRoundCounterReady))">
                <loading>
                    Loading
                    <template v-slot:subtitle>Found an opponent: {{ opponentName }}</template>
                </loading>
            </div>

            <div v-if="currentState == 1">
                <header class="header header--fixed">
                    <div class="container">
                        <div class="row align-items--center">
                            <div class="col-2 offset-10 text-right">
                                <a class="btn btn--icon btn--white"
                                   v-on:click.prevent="closeMatchMaking">
                                    <i class="material-icons">close</i>
                                </a>
                            </div>
                        </div>
                    </div>
                </header>

                <section class="fullscreen fullscreen--middle">
                    <div class="w--100 text--center">
                        <div class="container intro-content pt--40 pb--40">
                            <img src="/img/logo.png" alt="" class="intro-content__logo logo-loading mb--30" />

                            <h3 class="mb--0 dot-loading" v-if="privateChannel">Waiting for opponent...</h3>
                            <h3 class="mb--0" v-else-if="scholarGame">
                                <div>
                                    Welcome {{ nick }}!
                                </div>
                                <div class="dot-loading">Waiting for opponent</div>

                            </h3>
                            <h3 class="mb--0 dot-loading" v-else="!privateChannel">Searching for opponent...</h3>
                        </div>

                        <div class="pt--20 pb--30 bg--layer-light" v-if="privateChannel">
                            <div class="container">
                                <div class="row">
                                    <div class="col-8 mx--auto">
                                        <h4 class="text--xs text--uppercase opacity--md">Room code</h4>

                                        <div class="h1 mb--20">{{ privateChannel.id }}</div>

                                        <button type="button" class="btn btn--block btn--sm btn--white" @click="setClipboard(privateChannel.id)">Copy code</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <modal ref="alertTimeOut" show="false" type="error">
                    <template v-slot:title>
                        Time is up. The tournament has finished.
                    </template>

                    <template v-slot:buttons>
                        <button type="button" @click="emitFinishEvent()" class="btn btn--block btn--green">Go to dashboard</button>
                    </template>
                </modal>
            </div>

            <div v-if="currentState == 2">
                <loading>
                    Loading<template v-slot:subtitle>Found an opponent: {{ opponentName }}</template>
                </loading>
            </div>

            <div v-if="currentState == 3">

                <section :class="['fullscreen', 'game', {'game--blackout': blackOutIsActive }]">
                    <div class="container container-lg game__inner">
                        <div class="game__header mt--10">
                            <div class="game__info mb--md">
                                <div :class="['game__player', 'game__player--first', 'animated', 'bounceInLeft', preferences.profileColor, {'game__player--active': answered }]">
                                    <div class="game__player__inner">
                                        <div class="game__player__avatar">
                                            <img :src="avatar" alt="" />
                                            <span class="active"></span>
                                        </div>

                                        <div>
                                            <div class="game__player__name game__player__name--max-width">{{ nick }}</div>

                                            <div class="game__player__score">{{ points }}</div>
                                        </div>
                                    </div>

                                    <i class="material-icons" v-if="answered">check</i>
                                </div>

                                <div class="game__progress animated bounceInDown">
                                    <div :class="['game__progress__time', {'game__progress__time--active': timerActive}]" v-show="beforeGameCounterReady">
                                        <countdown @hook:mounted="countdownReady = true" ref="countdownTimer"
                                                   :speed="100" :left-time="20000" @finish="() => handleCountdownEnd()"
                                                   @process="(vac) => timeLeft(vac)">

                                            <div id="countdown-number" slot-scope="{ timeObj }"
                                                 class="game__progress__time game__progress__time--active">
                                                <span v-if="`${timeObj.leftTime}` < 10">0</span>
                                                <span v-else>{{ leftTimeSec }}</span>
                                                <svg>
                                                    <circle r="16" cx="19" cy="19" v-bind:style="timerStyle"></circle>
                                                </svg>
                                            </div>
                                        </countdown>

                                    </div>

                                    <div class="game__progress__title" v-if="question">LVL {{ question.level }} • {{ questionIndex }}/7</div>
                                </div>

                                <div :class="['game__player', 'game__player--last', 'animated', 'bounceInRight', opponentColor, {'game__player--active': opponentAnswered }]">
                                    <div class="game__player__inner">
                                        <div class="game__player__avatar">
                                            <img :src="opponentAvatar" alt=""/>
                                            <span class="active"></span>
                                        </div>

                                        <div>
                                            <div class="game__player__name game__player__name--max-width">
                                                {{ opponentName }}
                                            </div>

                                            <div class="game__player__score">{{ opponentPoints }}</div>
                                        </div>
                                    </div>

                                    <i class="material-icons" v-if="opponentAnswered">check</i>
                                </div>
                            </div>
                        </div>

                        <div class="game__body panel bg--layer-light text--center mb--md animated bounceInUp" v-if="!beforeGameCounterReady">
                            <div class="game__body__inner">
                                <div class="game__question">
                                    <div v-if="(beforeGameCounterValue -1) > 0" class="game__success game__success--animate">
                                        <strong>{{ beforeGameCounterValue - 1 }}</strong>
                                    </div>
                                    <div class="game__success game__success--animate" v-else><strong>GO!</strong></div>
                                </div>
                            </div>
                        </div>

                        <motivation-messages :good-answers-in-a-row="goodAnswersInARow" :show-message="showMessage"></motivation-messages>

                        <div class="game__body panel bg--layer-light text--center mb--md" v-if="beforeGameCounterReady && !showMessage">
                            <div class="game__body__inner">
                                <h4 class="text--xs opacity--md mb--sm">{{ question.group }}</h4>

                                <div :class="{'game__question': true, 'game__question--long': (question && question.question.length > 40) }">{{ question.question }}</div>
                            </div>
                        </div>

                        <form v-if="beforeGameCounterReady" class="row game__footer mb--0">

                            <div class="col-12 col-lg-6" v-for="answer in question.answers">
                                <button type="button" @click="sendAnswer(answer.id)"
                                        :class="{'btn': true, 'btn--action': true, 'mb--sm': true, 'btn--white': (!answered || (answered !== answer.id && answer.id !== correctAnswer)), 'btn--green': answered && answer.id === correctAnswer, 'btn--select': answered && answered == answer.id && answer.id !== correctAnswer}"
                                        :disabled="(answered && answered !== answer.id && answer.id !== correctAnswer) || hideAnswer(answer.id)">
                                    {{ answer.answer }}
                                    <div class="btn--action__icon btn--action__icon--right"
                                         v-if="opponentAnswered && answered && opponentAnswered == answer.id">
                                        <img :src="opponentAvatar" alt=""/>
                                    </div>

                                    <div class="btn--action__icon btn--action__icon--left"
                                         v-if="answered && answered == answer.id"
                                         :disabled="answered && answered == answer.id && answer.id !== correctAnswer">
                                        <img :src="avatar" alt="" />
                                    </div>
                                </button>
                            </div>

                        </form>

                        <div class="game__bottom pt--sm" v-if="beforeGameCounterReady && myPowerUps.length">
                            <p class="text--center text--uppercase mb--sm"><strong class="c--gradient-primary">Power Ups</strong></p>

                            <div class="row">
                                <component
                                    v-for="powerUp in myPowerUps"
                                    :is="componentNameFromClass(powerUp.type)"
                                    :power-up="powerUp"
                                    :answered="answered"
                                    :opponentAnswered="opponentAnswered"
                                    :key="powerUp.id">
                                </component>
                            </div>
                        </div>
                    </div>

                    <div class="game__layer game__layer--blackout">
                        <div class="game__layer__inner">
                            <svg class="icon"><use xlink:href="/img/icon-sprite.svg#blackout"></use></svg>

                            <h6 class="game__layer__title">Blackout</h6>

                            <p>{{ opponentName }} has blacked out your screen for 5 seconds. Get PowerUps!</p>
                        </div>
                    </div>

                </section>
            </div>
        </div>

        <div v-if="currentState == 4">

            <game-end
                :you-won="youWon"
                :home-player="nick"
                :home-player-points="points"
                :home-player-xp="homePlayerXp"
                :home-player-avatar="avatar"
                :away-player="opponentName"
                :away-player-points="opponentPoints"
                :away-player-avatar="opponentAvatar"
                :speed-bonus="speedBonus"
                :show-review="! knockoutGame"
                :show-help="! knockoutGame"
                :quiz-id="quizId"
                :perfect-game-bonus="perfectGameBonus"
            >
                <template v-slot:gameEndTextLosingPlayer>Ooh, that was close. <span v-if="! scholarGame && ! isGroupGame && ! knockoutGame">How about a rematch?</span></template>

                    <div v-if="scholarGame">
                        <router-link to="/" class="btn btn--action btn--white mb--sm">Go to Dashboard</router-link>
                    </div>

                    <div v-else-if="isGroupGame">
                        <button class="btn btn--action btn--purple mb--sm" @click="goToNextGame()">Start next game</button>
                        <button class="btn btn--action btn--white mb--sm" @click="emitFinishEvent()">Go to Room Dashboard</button>
                    </div>

                    <div class="game__footer mb--0" v-else-if="knockoutGame">

                        <div v-if="youWon && ! gameInfo.isLastRound" class="text--center text--lg weight--bold mb--10">
                            Waiting for next round...
                        </div>

                        <div v-else-if="youWon && gameInfo.isLastRound">
                            <div class="text--center text--lg weight--bold mb--10">
                                Congratulation, you won the tournament!
                            </div>

                            <button class="btn btn--action btn--white mb--sm" @click="emitFinishEvent()">Go to Room Dashboard</button>
                        </div>
                        <div v-else-if="! youWon">
                            <button class="btn btn--action btn--white mb--sm" @click="emitFinishEvent()">Go to Room Dashboard</button>
                        </div>
                    </div>

                    <div class="game__footer text--center mb--0" v-else>
                        <p class="opacity--sm" v-if="opponentWantsRematch && !wantsRematch && !opponentQuit">
                            Your opponent wants a rematch. Click Rematch if you do too.
                        </p>

                        <p class="opacity--sm" v-if="opponentQuit">
                            Your opponent has left the game.
                        </p>

                        <p class="opacity--sm" v-if="wantsRematch && !opponentQuit && !opponentWantsRematch">
                            Waiting for {{ opponentName }}...
                        </p>

                        <button @click="rematch" :disabled="wantsRematch || opponentQuit" class="btn btn--action btn--secondary mb--sm" type="button">Rematch</button>

                        <div>
                            <router-link to="/new-game" class="btn btn--action btn--primary mb--sm">Start new game</router-link>
                            <router-link to="/" class="btn btn--action btn--white mb--sm">Go to Dashboard</router-link>
                        </div>
                    </div>
            </game-end>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import api from "../../api/multiplayer"
    import simpleApi from "../../api/simpleGroupGame"
    import MotivationMessages from "./partial/MotivationMessages";
    import ScoreTable from "./partial/ScoreTable";
    import BlackOut from "../PowerUps/BlackOut";
    import Halving from "../PowerUps/Halving";

    export default {
        components: {ScoreTable, MotivationMessages, BlackOut, Halving},
        props: {
            privateGame: {
                required: false,
                default: false
            },
            scholarGame: {
                required: false,
                default: false
            },
            simpleGroupGame: {
                required: false,
                default: false
            },
            tournamentGroupGame: {
                required: false,
                default: false
            },
            knockoutGame: {
                required: false,
                default: false
            },
            code: {
                required: false,
                default: false
            }
        },
        data: function () {
            return {
                currentState: 0,
                opponentName: null,
                opponentAvatar: null,
                opponentColor: null,
                opponentWantsRematch: false,
                opponentQuit: false,
                privateChannel: null,
                channel: null,
                question: null,
                opponentAnswered: null,
                results: null,
                answered: false,
                nick: '',
                leftTime: 20000,
                leftTimeSec: 20,
                points: 0,
                opponentPoints: 0,
                questionIndex: 0,
                totalPoints: null,
                xp: null,
                wantsRematch: null,
                timerActive: true,
                goodAnswersInARow: 0,
                showMessage: false,
                countdownReady: false,
                blackOutIsActive: false,
                blackOutTimer: null,
                correctAnswer: null,
                beforeGameCounterReady: false,
                beforeGameCounterValue: 4,
                myPowerUps: [],
                answersToHide: [],
                beforeRoundCounterReady: false,
                beforeRoundCounterValue: 10,
                gameInfo: null,
            }
        },

        computed: {
            ...mapState('websocket', [
                'isConnected',
                'subscribedChannels'
            ]),
            ...mapState('auth', [
                'user'
            ]),
            ...mapGetters('auth', [
                'avatar',
                'preferences'
            ]),

            timerStyle() {
                let strokeLength = 16 * Math.PI * 2;

                if (this.leftTime < 5000) {
                    return {
                        stroke: '#D95656',
                        strokeDashoffset: strokeLength - (strokeLength / 20 * (Math.ceil(this.leftTime / 1000))) + 'px',
                        strokeDasharray: strokeLength + 'px',
                    }
                }

                return {
                    strokeDashoffset: strokeLength - (strokeLength / 20 * (Math.ceil(this.leftTime / 1000))) + 'px',
                    strokeDasharray: strokeLength + 'px',
                }
            },

            homePlayerWon() {
                if (this.totalPoints === null) {
                    return false;
                }

                if (! get(this.totalPoints, [this.nick, 'total_points'], null) || ! get(this.totalPoints, [this.opponentName, 'total_points'], null)) {
                    return false;
                }

                return get(this.totalPoints, [this.nick, 'total_points'], 0) > get(this.totalPoints, [this.opponentName, 'total_points'], 0)
            },

            awayPlayerWon() {
                if (this.totalPoints === null) {
                    return false;
                }

                if (! get(this.totalPoints, [this.nick,'total_points'], null) || ! get(this.totalPoints, [this.opponentName, 'total_points'], null)) {
                    return false;
                }

                return get(this.totalPoints, [this.nick, 'total_points'], 0) < get(this.totalPoints, [this.opponentName, 'total_points'], 0)
            },

            perfectGameBonus() {
                return get(this.totalPoints, [this.nick, 'perfectGame'])
            },

            speedBonus() {
                return get(this.totalPoints, [this.nick, 'speedBonus'])
            },

            homePlayerXp() {
                return get(this.xp, [this.nick], 0)
            },

            quizId() {
                return get(this.question, 'quiz_id')
            },

            youWon() {
                if (get(this.totalPoints, [this.nick, 'total_points'], 0) > get(this.totalPoints, [this.opponentName, 'total_points'], 0)) {
                    return true
                }

                return false
            },

            isGroupGame() {
                return this.simpleGroupGame || this.tournamentGroupGame
            }
        },

        methods: {
            timeLeft(props) {
                this.leftTime = props.timeObj.leftTime
                this.leftTimeSec = props.timeObj.ceil.s
            },

            async generateNick() {
                let response = await api.generateNick()

                this.nick = response.data.nick
            },

            rematch() {
                this.wantsRematch = true

                this.send({
                    event: "wantsRematch",
                    data: {
                        channel: this.channel,
                    }
                })
            },

            start() {
                if (! this.isConnected) {
                    return false
                }

                this.timerActive = true

                if (this.scholarGame) {
                    if (! this.nick) {
                        let channelData = collect(this.subscribedChannels).where('channel', 'scholar-' + this.code).first()
                        this.nick = channelData.data.nick
                    }
                    this.currentState = 1

                    return
                }

                if (this.isGroupGame || this.knockoutGame) {
                    this.currentState = 1

                    return
                }

                if (! this.nick.length) {
                    return false
                }

                if (this.code && this.privateGame) {
                    this.privateChannel = {
                        id: this.code,
                        name: 'invited',
                    }
                    this.subscribeToPrivateGame()
                    this.currentState = 1
                    return
                }

                if (! this.privateGame && ! this.scholarGame) {
                    this.subscribeToMatchmaking()
                } else {
                    this.createPrivateChannel().then((response) => {
                        this.privateChannel = response.data.data
                        this.subscribeToPrivateGame()
                    })

                }

                this.currentState = 1
            },

            async createPrivateChannel() {
                try {
                    return await api.createPrivateChannel()
                } catch (e) {
                    console.log(e)
                }
            },

            handleCountdownEnd() {

                this.timerActive = false
                if (this.answered) {
                    return;
                }

                this.answered = -1
                this.goodAnswersInARow = 0

                this.send(
                    {
                        event: "answer",
                        data: {
                            channel: this.channel,
                            answerId: null,
                            questionId: this.question.question_id,
                            leftTime: 0
                        }
                    }
                )

                this.clearBlackOut()
            },

            sendReadyStatus() {
                setTimeout(() => {
                    this.send({
                        event: "ready",
                        data: {
                            channel: this.channel
                        }
                    })
                }, 3000);
            },

            getMatchMakingChannelName() {

                if (this.simpleGroupGame) {
                    return 'simple-group-' + this.code
                }

                if (this.tournamentGroupGame) {
                    return 'tournament-group-' + this.code
                }

                return 'matchmaking'
            },

            stopCountdownTimer() {
                if (this.$refs.countdownTimer && this.$refs.countdownTimer !== undefined) {
                    this.$refs.countdownTimer.stopCountdown()
                }
            },

            sendAnswer(answerId) {
                //this.$refs.countdownTimer.stopCountdown()
                if (this.answered) {
                    console.log('already answered');
                    return;
                }

                this.timerActive = false
                this.answered = answerId

                this.send(
                    {
                        event: "answer",
                        data: {
                            channel: this.channel,
                            answerId: answerId,
                            questionId: this.question.question_id,
                            leftTime: this.leftTime
                        }
                    }
                )
            },

            emitFinishEvent() {
                Quiz.$emit('game-finished', this.channel)
                if (this.$refs.alertTimeOut) {
                    this.$refs.alertTimeOut.close()
                }
            },

            enterToMatchMaking() {
                this.send({
                    event: "enterToMatchmaking",
                    data: {
                        channel: this.getMatchMakingChannelName(),
                    }
                });

                this.start()
            },

            goToNextGame() {
                this.resetProps()

                simpleApi.findGame(this.code).then((response) => {

                    if (response.data.data.type === 'simple_group_game') {
                        this.enterToMatchMaking()
                        return
                    }

                    if (! response.data.data.remainingTime && response.data.data.endDate) {
                        this.$refs.alertTimeOut.open()
                        return
                    }

                    if (! response.data.data.game_limit) {
                        this.enterToMatchMaking()
                        return
                    }

                    let numberOfQuizess = collect(response.data.data.childQuizess)
                        .filter((item) => item.status === 'finished' && collect(item.quizUsers).where('user_id', this.user.id).count())
                        .count()

                    if (response.data.data.game_limit <= numberOfQuizess) {
                        this.$refs.alertTimeOut.open()
                        return
                    }

                    this.enterToMatchMaking()
                }).catch( (error) => {
                    console.log(error)
                    this.$refs.alertModal.open()
                })
            },

            resetProps() {
                if (! this.knockoutGame) {
                    this.currentState = 1;
                    this.gameInfo = {isLastRound: false};
                }

                this.opponentName = null;
                this.opponentAvatar = null;
                this.question = null;
                this.opponentAnswered = null;
                this.goodAnswersInARow = 0
                this.showMessage = false
                this.results = null;
                this.answered = false;
                this.points = 0;
                this.opponentPoints = 0;
                this.questionIndex = 0;
                this.timerActive = true
                this.totalPoints = null
                this.xp = null
                this.beforeGameCounterReady = false
                this.beforeGameCounterValue = 4
                this.beforeRoundCounterReady = false
                this.beforeRoundCounterValue = 10
                this.wantsRematch = false
                this.blackOutIsActive = false
                this.blackOutTimer = null
                this.opponentWantsRematch = false
                this.opponentQuit = false
                this.myPowerUps = []
                this.answersToHide = []
                this.correctAnswer = null
            },

            pollMatchMaking() {
                this.polling = setInterval(() => {
                    this.send({
                        event: "matchMaking",
                        data: {
                            channel: this.getMatchMakingChannelName()
                        }
                    })
                    this.showMessage = false
                }, 8000)
            },

            subscribeToMatchmaking() {
                this.subscribe('matchmaking', {
                    nick: this.nick
                })
            },

            subscribeToPrivateGame() {
                this.subscribe('match-' + this.privateChannel.id)
            },

            startTimer() {
                this.leftTime = 20 * 1000
                if (this.countdownReady && this.$refs.countdownTimer !== undefined) {
                    this.$refs.countdownTimer.startCountdown(true)
                }
            },

            closeMatchMaking() {
                if (this.isGroupGame || this.knockoutGame) {
                    this.emitFinishEvent()
                } else {
                    Quiz.$emit('disconnect')
                    this.$router.push('/')
                }
            },

            hideAnswer(id) {
                return collect(this.answersToHide).contains(id)
            },

            clearBlackOut() {
                if (! this.blackOutTimer) {
                    return
                }

                clearTimeout(this.blackOutTimer)
                this.blackOutIsActive = false
            }
        },

        created() {
            clearInterval(this.polling)

            Quiz.$off('finish')
            Quiz.$off('opponent_answered')
            Quiz.$off('opponent_quit')
            Quiz.$off('my_power_ups')
            Quiz.$off('use_power_up')
            Quiz.$off('power_up')
            Quiz.$off('under_black_out')
            Quiz.$off('answer_received')
            Quiz.$off('question')
            Quiz.$off('opponent_found')
            Quiz.$off('play_against_com')
            Quiz.$off('wants_rematch')
            Quiz.$off('need_to_confirm')
            Quiz.$off('next-round-started')
            Quiz.$off('power_up_is_not_appliable')

            Quiz.$on('need_to_confirm', (message) => {

                this.resetProps();

                this.currentState = 6
                this.opponentName = message.data.opponentName
                this.channel = message.data.channel

                if (this.knockoutGame) {
                    let counter = setInterval(() => {
                        if (this.beforeRoundCounterValue > 0) {
                            --this.beforeRoundCounterValue
                        }

                        if (this.beforeRoundCounterValue === 0) {
                            clearInterval(counter)
                            this.beforeRoundCounterReady = true

                            this.send({
                                event: "connection_confirm",
                                data: {
                                    channel: message.data.channel
                                }
                            })
                        }
                    }, 1000)

                    return;
                }

                this.send({
                    event: "connection_confirm",
                    data: {
                        channel: message.data.channel
                    }
                })
            })

            Quiz.$on('opponent_found', (message) => {
                this.resetProps()

                if (! this.nick) {
                    this.nick = message.data.nick
                }
                this.opponentName = message.data.opponentName
                this.opponentAvatar = message.data.opponentAvatar
                this.channel = message.data.channel
                this.gameInfo = get(message.data, 'gameInfo')
                this.currentState = 2
                this.sendReadyStatus()
            })

            Quiz.$on('answer_received', (message) => {

                if (message.data.points > 0) {
                    ++this.goodAnswersInARow
                    this.showMessage = true
                } else {
                    this.goodAnswersInARow = 0
                }

                this.points += message.data.points
                this.opponentPoints += message.data.opponentPoints
                this.opponentAnswered = message.data.opponentAnswered
                this.correctAnswer = message.data.correctAnswer

                this.sendReadyStatus()
            })

            Quiz.$on('my_power_ups', (message) => {
                this.myPowerUps = message.data
            })

            Quiz.$on('power_up_is_not_appliable', (message) => {
                this.myPowerUps = collect(this.myPowerUps).map((item) => {
                    if (item.id == message.data.power_up.id) {
                        item.quantity = 1
                        return item
                    }
                    return item
                }).toArray()
            })

            Quiz.$on('power_up', (message) => {
                if (message.data.type == 'blackout') {
                    this.blackOutIsActive = true
                    this.blackOutTimer = setTimeout(() => {
                        this.blackOutIsActive = false
                    }, 5000);
                }

                if (message.data.type == 'halving') {
                    this.answersToHide = message.data.answers_to_hide
                }
            })

            Quiz.$on('use_power_up', (powerUp) => {
                this.myPowerUps = collect(this.myPowerUps).map((item) => {
                    if (item.id == powerUp.id) {
                        item.quantity = 0
                        return item
                    }
                    return item
                }).toArray()

                this.send({
                    event: "powerUp",
                    data: {
                        channel: this.channel,
                        power_up: powerUp.id,
                    }
                });
            })


            Quiz.$on('under_black_out', () => {
                this.timerActive = true
                this.answered = false
            })

            Quiz.$on('question', (message) => {
                this.clearBlackOut()

                this.answersToHide = []
                this.correctAnswer = null
                this.answered = false
                this.opponentAnswered = false;
                this.question = message.data.question;
                this.currentState = 3;
                this.questionIndex++;
                this.showMessage = false

                if (! this.beforeGameCounterReady) {
                    let counter = setInterval(() => {
                        if (this.beforeGameCounterValue > 0) {
                            --this.beforeGameCounterValue
                        }

                        if (this.beforeGameCounterValue === 0) {
                            clearInterval(counter)
                            this.beforeGameCounterReady = true
                            this.startTimer();
                        }
                    }, 1000)
                } else {
                    this.startTimer();
                }
            })

            Quiz.$on('play_against_com', () => {
                clearInterval(this.polling)
                this.$router.push('/game/play-against-computer')
            })

            Quiz.$on('wants_rematch', () => {
                this.opponentWantsRematch = true
            })

            Quiz.$on('opponent_answered', () => {
                this.opponentAnswered = true
            })

            Quiz.$on('opponent_quit', () => {
                this.clearBlackOut()


                if (this.knockoutGame) {

                    if (this.currentState == 4) {
                        return
                    }

                    if (this.channel) {
                        this.unsubscribe(this.channel)
                    }
                    this.currentState = 5

                    return
                }

                if ([2, 1, 0, 6].includes(this.currentState)) {
                    if (this.channel) {
                        this.unsubscribe(this.channel)
                    }

                    this.resetProps();
                    this.subscribeToMatchmaking()

                    return
                }

                if (this.questionIndex < 2) {
                    if (this.channel) {
                        this.unsubscribe(this.channel)
                    }
                    this.currentState = 5

                    return
                }

                this.opponentQuit = true
            })

            Quiz.$on('finish', (message) => {
                this.clearBlackOut()

                this.results = message.data.results;
                this.totalPoints = message.data.totalPoints;
                this.xp = message.data.xp;

                this.points = get(message.data.totalPoints, [this.nick, 'total_points'], this.points)
                this.opponentPoints = get(message.data.totalPoints, [this.opponentName, 'total_points'], this.opponentPoints)

                this.showMessage = false

                this.currentState = 4

                if (this.scholarGame || this.isGroupGame || this.knockoutGame) {
                    this.unsubscribe(this.channel)
                }

                this.$refs.countdownTimer.stopCountdown()
            })

            Quiz.$on('next-round-started', () => {
                this.resetProps()
                this.start()
            })

            this.opponentColor = this.preferences.profileColor === 'blue' ? 'pink' : 'blue'

            if (this.user) {
                this.nick = this.user.nick
            }

            this.start();
        },

        watch: {
            currentState: function (step) {

                if ([4, 5].includes(step)) {
                    $('html').removeClass('mobile-fixed-screen')
                    this.stopCountdownTimer()
                } else {
                    $('html').addClass('mobile-fixed-screen')
                }

                if (this.privateGame || this.scholarGame || this.knockoutGame) {
                    return
                }

                if (step !== 1) {
                    clearInterval(this.polling)
                } else {
                    this.pollMatchMaking()
                }
            },

            isConnected: function (value) {
                if (value) {
                    //this.subscribeToMatchmaking()
                    //this.pollMatchMaking()
                } else {
                    clearInterval(this.polling)
                }
            }
        },

        beforeDestroy() {
            clearInterval(this.polling)
            Quiz.$off('finish')
            Quiz.$off('opponent_answered')
            Quiz.$off('opponent_quit')
            Quiz.$off('answer_received')
            Quiz.$off('question')
            Quiz.$off('opponent_found')
            Quiz.$off('play_against_com')
            Quiz.$off('wants_rematch')
            Quiz.$off('need_to_confirm')
            Quiz.$off('next-round-started')

            Quiz.$off('my_power_ups')
            Quiz.$off('use_power_up')
            Quiz.$off('power_up')
            Quiz.$off('under_black_out')
            Quiz.$off('power_up_is_not_appliable')
            if (! this.isGroupGame && ! this.knockoutGame) {
                this.unsubscribe('all')
            }
        }
    }
</script>
